export default __webpack_public_path__ + "static/media/awardIcon.058ca28e.png";